import { render } from "./OffcanvasPrinterSettings.vue?vue&type=template&id=82c2b1b2&scoped=true"
import script from "./OffcanvasPrinterSettings.vue?vue&type=script&lang=js"
export * from "./OffcanvasPrinterSettings.vue?vue&type=script&lang=js"

import "./OffcanvasPrinterSettings.vue?vue&type=style&index=0&id=82c2b1b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c2b1b2"]])

export default __exports__